var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9628 18 18 13.9628 18 9C18 4.03724 13.9628 3.52947e-07 9 7.86805e-07C4.03724 1.22066e-06 -1.22066e-06 4.03724 -7.86805e-07 9C-3.52947e-07 13.9628 4.03724 18 9 18ZM4.71976 9.96975L8.46974 6.21974C8.61599 6.07349 8.80798 5.99998 9 5.99998C9.19202 5.99998 9.38401 6.07349 9.53026 6.21974L13.2802 9.96975C13.5735 10.263 13.5735 10.737 13.2802 11.0302C12.987 11.3235 12.513 11.3235 12.2197 11.0302L9 7.81049L5.78025 11.0302C5.48701 11.3235 5.013 11.3235 4.71976 11.0302C4.42649 10.737 4.42649 10.263 4.71976 9.96975Z",
    fill: "#00406A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpToggle);
export default __webpack_public_path__ + "static/media/upToggle.2825b40f0d795cf9b484124716a03710.svg";
export { ForwardRef as ReactComponent };